<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('DriverManagement.trainTitle')">
                    <el-input
                      size="mini"
                      v-model="formInline.trainTitle"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.examEndTime')">
                    <el-date-picker
                      v-model="formInline.driverExpires"
                      type="daterange"
                      style="width: 220px"
                      size="mini"
                      value-format="yyyy-MM-dd"
                      range-separator
                      :start-placeholder="$t('common.btn.choseDate')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                  v-if="isPrimaryKey('DRIVERTRAIN_DOWNLOADEXAMPERSONNELTEMPLATE')"
                  type="text"
                  @click="DriveImport()"
                  >{{
                    $t("DriverManagement.form.downloadExamPeopleModle")
                  }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('DRIVERTRAIN_DOWNLOADEXAMQUESTIONTEMPLATE')"
                  type="text"
                  @click="topicImport()"
                  >{{
                    $t("DriverManagement.form.downloadExamQuestionModle")
                  }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('DRIVERTRAIN_EDIT')"
                  type="text"
                  :disabled="editDisabled"
                  @click="editDriver"
                  >{{ $t("common.btn.edit") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('DRIVERTRAIN_DELETE')"
                  type="text"
                  :disabled="delDisabled"
                  @click="deleteDriver"
                  >{{ $t("common.btn.delete") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('DRIVERTRAIN_SUBMIT')"
                  type="text"
                  :disabled="submitDisabled"
                  @click="submitBtn"
                  >{{ $t("common.btn.submit") }}</el-button
                >
                <el-button
                  v-if="isPrimaryKey('DRIVERTRAIN_ADD')"
                  type="text"
                  @click="addDriver"
                  >{{ $t("common.btn.add") }}</el-button
                >
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="820px"
        :before-close="closeDia"
        class="carDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="trainTitle"
            :label="$t('DriverManagement.trainTitle') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.trainTitle"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="examEndTime"
            :label="$t('DriverManagement.examEndTime') + ':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.btn.choseDate')"
              v-model="form.examEndTime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="examDuration"
            :label="$t('DriverManagement.examDuration') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.examDuration"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="examPassMark"
            :label="$t('DriverManagement.examPassMark') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.examPassMark"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="trainQuestionFile"
            :label="$t('DriverManagement.examQuestion') + ':'"
            :label-width="formLabelWidth"
          >
            <input @change="uploadTopic()" id="uploadTopic" type="file" style="display: none;" />
            <el-button type="primary" size="small" @click="triggerTopicUpload()">{{ $t("common.btn.uploadFile") }}</el-button>
          </el-form-item>
          <el-form-item
            prop="trainDriverFile"
            :label="$t('DriverManagement.examDriver') + ':'"
            :label-width="formLabelWidth"
          >
            <input @change="uploadDriver()" id="uploadDriver" type="file" style="display: none;" />
            <el-button type="primary" size="small" @click="triggerDriverUpload()">{{ $t("common.btn.uploadFile") }}</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="1200px"
        :before-close="closeOperateDia"
        class="tableDialong"
        :title="OperateTitle"
        :visible.sync="dialogOperateFormVisible"
        :close-on-click-modal="false"
      >
        <div class="zMsgSearch">
          <el-form :inline="true" :model="formTable" class="demo-form-inline">
            <el-form-item
              :label="$t('DriverManagement.numOrName')"
              v-if="isDisplay"
            >
              <el-input
                size="mini"
                v-model="formTable.number"
                :placeholder="$t('common.searchTip')"
                style="width: 150px"
                class="input-with-select"
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('DriverManagement.examStateStr')"
              v-if="isShow"
            >
              <el-select
                v-model="formTable.examState"
                :placeholder="$t('DriverManagement.examStateStr')"
                filterable
                size="mini"
                style="width: 120px"
              >
                <el-option
                  v-for="item in StateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="$t('DriverManagement.examResult')"
              v-if="isShow"
            >
              <el-select
                v-model="formTable.examResult"
                :placeholder="$t('DriverManagement.examResult')"
                filterable
                size="mini"
                style="width: 120px"
              >
                <el-option
                  v-for="item in ResultList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="isDisplay">
              <el-button
                size="mini"
                type="primary"
                @click="Search"
                class="btn-chaxun"
                >{{ $t("common.btn.search") }}</el-button
              >
              <el-button size="mini" @click="Clear" class="btn-del">{{
                $t("common.btn.cancel")
              }}</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="zMsgBtn">
          <el-button type="text" @click="down">{{
            $t("common.btn.download")
          }}</el-button>
        </div>
        <div class="zMsgTable">
          <i-table
            :list="authorizeList"
            :height="authorizeHeight"
            ref="authorizeTable"
            :options="authorizeOption"
            :columns="AllColumns"
            :operates="authorizeOperates"
          ></i-table>
          <IPagination
            v-if="isDisplay"
            ref="AuthorizePage"
            @PageFun="changeAuthorizeSize"
          ></IPagination>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DriverTrain from "./DriverTrain.js";
export default DriverTrain;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
